module.exports = __webpack_public_path__ + "static/media/nl.db2b8b18.svg";